export default {
      id: "complete-usage",
      viewBox: "0 0 20 24",
      url: __webpack_public_path__ + "sprite-46b249.svg#complete-usage",
      toString: function () {
        return this.url;
      }
    }